import request from '@/utils/request'

/**
 * 获取入驻小区审核列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listCommunitys(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/auditEnterCommunityManage.list',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 审核入驻小区
 * @param {Object} data 审核数据
 * @returns {Promise} Promise对象
 */
export function auditCommunity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/auditEnterCommunityManage.audit',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 撤回审核
 * @param {Object} data 撤回数据
 * @returns {Promise} Promise对象
 */
export function recallAudit(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/auditEnterCommunityManage.recall',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}